var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUserinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M8.67 12h6.66a2 2 0 0 1 1.969 1.642l1.487 8.18A1 1 0 0 1 17.802 23H6.198a1 1 0 0 1-.984-1.179l1.487-8.179A2 2 0 0 1 8.67 12zM12 9a4 4 0 1 1 0-8 4 4 0 0 1 0 8z"
})));
export default SvgUserinline;